export function SidebarSeparator() {
  return <div aria-hidden="true" className="bg-ink-100 h-px w-full shrink-0" />
}
